import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "authenticationSlice",
    initialState: {
        // loginData: "",
        loginData: JSON.parse(localStorage.getItem("loginData")) || "",
        token: localStorage.getItem("token"),
        accessToken: localStorage.getItem("accessToken"),
        email: localStorage.getItem("email"),
        mobile: localStorage.getItem("mobile"),
        userType: localStorage.getItem("userType"),
        selectedUserType: localStorage.getItem("selectedUserType"),
        username: localStorage.getItem("username"),
        userId: localStorage.getItem("userId"),
        login: localStorage.getItem("login"),
        inviteCode: localStorage.getItem("inviteCode"),
        selectedUserType: localStorage.getItem("selectedUserType")
    },
    reducers: {
        LOGIN_SUCCESS: (state, action) => {
            const loginData = action.payload;
            localStorage.setItem("loginData", JSON.stringify(loginData));
            return {
                ...state,
                loginData:loginData,
                token: localStorage.getItem("token"),
                accessToken: localStorage.getItem("accessToken"),
                email: localStorage.getItem("email"),
                mobile: localStorage.getItem("mobile"),
                userType: localStorage.getItem("userType"),
                username: localStorage.getItem("username"),
                userId: localStorage.getItem("userId"),
                login: localStorage.getItem("login"),
                inviteCode: localStorage.getItem("inviteCode"),
                selectedUserType: localStorage.getItem("selectedUserType")
            };
        },
        LOGIN_ERROR: (state) => {
            return {
                ...state,
                loginData: "",
                token: "",
                accessToken:"",
                email: "",
                mobile: "",
                userType: "",
                username:"",
                selectedUserType:"",
                login:"",
                inviteCode:""
            };
        },
    },
});

export const { LOGIN_SUCCESS, LOGIN_ERROR } = slice.actions;
export default slice.reducer;
